import React from 'react'

const Blogbanner1 = () => {
  return (
    <>
     <section className="tf-slider blog1  parallax">
            <div className="content"></div>
            <div className="container ">
                <div className="row ">
                    <div className="col-lg-12">
                        {/* <FormContent /> */}
                    </div>
                </div>
            </div>
            <div className="overlay"></div>
        </section>
    </>
  )
}

export default Blogbanner1